<div class="table-cell" (click)="goToExercise()">
  <img class="table-cell-emoji" src="assets/plan/exercise.png" alt="" />
  <div class="table-cell-title">
    <p>
      فعالیت (<span>{{ calories.toFixed(0) }}</span> کالری)
    </p>
  </div>
  <img class="table-cell-icon" src="assets/general/left-gray.svg" />
</div>
